import { Chip } from '@mui/material';

import type { PatientInfoResponse } from '../store/api';

/** Keep active and legacy records quiet; only flag explicitly inactive patients. */
export const PatientInactiveBadge = ({
  activityStatus,
}: {
  activityStatus: PatientInfoResponse['activity_status'];
}) =>
  activityStatus === 'inactive' ? (
    <Chip
      label="Inactive"
      size="small"
      sx={{ height: 20, fontSize: '0.6875rem', color: 'text.secondary', flexShrink: 0 }}
    />
  ) : null;
